/* Version 1.4 - April 2022 */
(function ($) {
    $.fn.formTools = function (options) {
        const default_options = {
                displaySpinner: true,
                useDefaultOnFail: true,
                customOnComplete: false,
                customOnSuccess: false,
                customOnFail: false,
                customOnStart: false,
                customAppendData: false,
            },
            _onFail = function (el_form, response) {
                let full_error_messages = '';

                $.each(response.errors, function (input_target_name, error_message) {
                    let el_target = false;

                    // compose error_message
                    full_error_messages += `<p>${error_message.join("<br />")}</p>`;

                    el_target = el_form.find(
                        `input[name="${input_target_name}"],` +
                        `input[name="${input_target_name}[]"],` +
                        `textarea[name="${input_target_name}"],` +
                        `select[name="${input_target_name}"],` +
                        `#${input_target_name},` +
                        `[data-input-group-key="${input_target_name}"]`
                    );

                    // highlight target input(s)
                    if (el_target.length) {
                        let el_input_style = el_target.closest(".input-style,.input-group-style");

                        if (el_input_style.length === 0) {
                            el_input_style = el_target.find(".input-style,.input-group-style");
                        }

                        if (el_input_style.length) {
                            el_input_style.addClass('invalid-feedback');

                            el_target.bind("change", function () {
                                el_input_style.removeClass('invalid-feedback');
                            });
                        }
                    }
                });

                const responses_notification = response.hasOwnProperty("notification") ? response.notification : false;

                // create a new notification using $full_error_message with default heading
                let final_notification = {
                    type: 'error',
                    heading: 'Failed to submit form'
                };

                if (full_error_messages) {
                    final_notification.message = full_error_messages;

                    // if the response contains a notification, merge $final_notification with that one, by using the response info to set $final_notification's heading
                    if (responses_notification) {
                        if (responses_notification.heading) {
                            final_notification.heading = responses_notification.title;

                        } else {
                            final_notification.heading = responses_notification.message;
                        }
                    }
                } else {
                    final_notification = responses_notification;
                }

                maggieland.addToast(final_notification, final_notification.auto_dismiss ?? 0);
            },
            _submitForm = function (e) {
                e.preventDefault();

                const el_form = $(e.target);

                if (options.displaySpinner) {
                    maggieland.showSpinner();
                }

                if (typeof options.customOnStart === "function") {
                    options.customOnStart(el_form, options);
                }

                // clear all existing error highlight
                el_form.find('.invalid-feedback').removeClass('invalid-feedback');

                // remove all existing toasts
                maggieland.removeAllToasts();

                const url = el_form.attr('action'),
                    method = el_form.attr('method');

                let submit_data;

                if (method.toUpperCase() === 'POST') {
                    submit_data = new FormData(this);
                } else {
                    submit_data = el_form.serialize();
                }

                if (typeof options.customAppendData === "function") {
                    options.customAppendData(el_form, options, submit_data);
                }

                $.ajax({
                    type: method,
                    url: url,
                    data: submit_data,
                    cache: false,
                    contentType: false,
                    processData: false,
                    dataType: 'JSON',
                    success: function (response) {
                        if (response.success) {
                            // has custom onSuccess function
                            if (typeof options.customOnSuccess === "function") {
                                options.customOnSuccess(el_form, response, options);
                            }

                        } else {
                            if (options.useDefaultOnFail) {
                                _onFail(el_form, response, options);
                            }

                            // has custom onFail function
                            if (typeof options.customOnFail === "function") {
                                options.customOnFail(el_form, response, options);
                            }
                        }
                    },
                    error: function (xhr, text_status, error_thrown) {
                        console.log("formtool error()");
                        if (xhr.responseJSON && xhr.responseJSON.hasOwnProperty('exception')) {
                            maggieland.addToast({
                                type: 'error',
                                message: xhr.responseJSON.exception.message,
                                heading: 'Failed to submit form'
                            });

                        } else {
                            console.error(`[${text_status}] An error occurred during form submission.\nA ${method} request to ${url} returned: {${xhr.responseText}.`);
                        }
                    },
                    complete: function (xhr) {
                        console.log("formtool complete()");
                        // This always get trigger after success() or error()
                        if (options.displaySpinner) {
                            maggieland.hideSpinner();
                        }

                        // has custom onComplete function
                        if (typeof options.customOnComplete === "function") {
                            options.customOnComplete(el_form, xhr, options);
                        }
                    }
                });
            };

        // extends options
        options = $.extend(default_options, options);

        return this.each(function () {
            const el_form = $(this);
            el_form.on('submit', _submitForm);
        });
    }
})(jQuery);
